interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/** Panel-on-the-right glyph for the input panel show/hide toggle. */
const FigmaSidePanelIcon = ({ width = 14, height = 14, color = '#5B6472' }: Properties) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect x='1.25' y='2.75' width='13.5' height='10.5' rx='1.75' stroke={color} strokeWidth='1.3' />
    <path d='M10 3.5V12.5' stroke={color} strokeWidth='1.3' strokeLinecap='round' />
    <rect x='10.9' y='3.4' width='4.2' height='9.2' rx='1.2' fill={color} fillOpacity='0.28' />
  </svg>
);

export default FigmaSidePanelIcon;
